import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { OutOfTimeComponent } from './out-office.component';

@NgModule({
  declarations: [OutOfTimeComponent],
  exports: [OutOfTimeComponent],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OutOfTimeModule {}
